<template>
  <div><ProgressSpinner /></div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      done: false,
      refresh: true,
    };
  },
  computed: {
    token() {
      return this.getURLParam("invitation_token");
    },
    validEmail() {
      return this.validateEmail(this.email);
    },
  },
  methods: {
    fetchData() {
      api
        .acceptInvitation(this.$route.params.id)
        .then(response => {
          setTimeout(() => {
            this.makeToast("info", response.data.message);
            if (this.refresh) {
              this.refreshLeagueInformation("/");
            }
          }, 1000);
        })
        .catch(error => {
          this.makeToast("error", error.response.data.error);
          this.goRouter("/");
        });
    },
  },
  mounted() {
    if (this.getURLParam("refresh") == 1) {
      this.refresh = false;
    }
    this.fetchData();
  },
};
</script>

<style scoped lang="scss">
form {
  margin-top: 1rem;
}
.error {
  text-align: center;
}
</style>
